import type { FC, SVGProps } from "react"

import ArrowRightIconSvg from "./arrow-right.svg"
import AssistantIconSvg from "./assistant.svg"
import CardIconSvg from "./card.svg"
import CasinoIconSvg from "./casino.svg"
import CheckIconSvg from "./check.svg"
import ChevronLeftIconSvg from "./chevron-left.svg"
import CopyIconSvg from "./copy.svg"
import CrossIconSvg from "./cross.svg"
import CrownIconSvg from "./crown.svg"
import ExitIconSvg from "./exit.svg"
import FaqIconSvg from "./faq.svg"
import FilterIconSvg from "./filter.svg"
import FullscreenIconSvg from "./fullscreen.svg"
import HeartIconSvg from "./heart.svg"
import HideSidebarIconSvg from "./hide-sidebar.svg"
import HistoryIconSvg from "./history.svg"
import LiveIconSvg from "./live.svg"
import LocationIconSvg from "./location.svg"
import LockIconSvg from "./lock.svg"
import MailIconSvg from "./mail.svg"
import MenuIconSvg from "./menu.svg"
import NotificationIconSvg from "./notification.svg"
import OriginalsIconSvg from "./originals.svg"
import PlayIconSvg from "./play.svg"
import PopularIconSvg from "./popular.svg"
import PromotionsIconSvg from "./promotions.svg"
import ProvidersIconSvg from "./providers.svg"
import RecentIconSvg from "./recent.svg"
import ResponsibleIconSvg from "./responsible.svg"
import SearchIconSvg from "./search.svg"
import ShieldIconSvg from "./shield.svg"
import SlotsIconSvg from "./slots.svg"
import SportsIconSvg from "./sports.svg"
import StarIconSvg from "./star.svg"
import SupportIconSvg from "./support.svg"
import TrophyIconSvg from "./trophy.svg"
import UserIconSvg from "./user.svg"
import UsersIconSvg from "./users.svg"
import WalletIconSvg from "./wallet.svg"

export type IconComponent = FC<SVGProps<SVGSVGElement>>

export const ArrowRightIcon: IconComponent = ArrowRightIconSvg
export const AssistantIcon: IconComponent = AssistantIconSvg
export const CardIcon: IconComponent = CardIconSvg
export const CasinoIcon: IconComponent = CasinoIconSvg
export const CheckIcon: IconComponent = CheckIconSvg
export const ChevronLeftIcon: IconComponent = ChevronLeftIconSvg
export const CopyIcon: IconComponent = CopyIconSvg
export const CrossIcon: IconComponent = CrossIconSvg
export const CrownIcon: IconComponent = CrownIconSvg
export const FaqIcon: IconComponent = FaqIconSvg
export const FilterIcon: IconComponent = FilterIconSvg
export const HideSidebarIcon: IconComponent = HideSidebarIconSvg
export const HistoryIcon: IconComponent = HistoryIconSvg
export const LiveIcon: IconComponent = LiveIconSvg
export const LocationIcon: IconComponent = LocationIconSvg
export const LockIcon: IconComponent = LockIconSvg
export const MailIcon: IconComponent = MailIconSvg
export const MenuIcon: IconComponent = MenuIconSvg
export const NotificationIcon: IconComponent = NotificationIconSvg
export const OriginalsIcon: IconComponent = OriginalsIconSvg
export const PlayIcon: IconComponent = PlayIconSvg
export const PopularIcon: IconComponent = PopularIconSvg
export const PromotionsIcon: IconComponent = PromotionsIconSvg
export const ProvidersIcon: IconComponent = ProvidersIconSvg
export const RecentIcon: IconComponent = RecentIconSvg
export const ResponsibleIcon: IconComponent = ResponsibleIconSvg
export const SearchIcon: IconComponent = SearchIconSvg
export const ShieldIcon: IconComponent = ShieldIconSvg
export const SlotsIcon: IconComponent = SlotsIconSvg
export const SportsIcon: IconComponent = SportsIconSvg
export const StarIcon: IconComponent = StarIconSvg
export const SupportIcon: IconComponent = SupportIconSvg
export const TrophyIcon: IconComponent = TrophyIconSvg
export const UserIcon: IconComponent = UserIconSvg
export const UsersIcon: IconComponent = UsersIconSvg
export const WalletIcon: IconComponent = WalletIconSvg
export const ExitIcon: IconComponent = ExitIconSvg
export const HeartIcon: IconComponent = HeartIconSvg
export const FullscreenIcon: IconComponent = FullscreenIconSvg
